import config from 'init/config';
import { fRequest } from 'utilities/api';

export const api_AddToBuckCart = (productSlug, quantity) => {
  return fRequest(`${config.buckRootUrl}/api/order/add/`, {
    method: 'POST',
    data: [{ product_slug: productSlug, quantity: quantity }]
  });
};
